<!-- display-desktop-13 preview — a display ad in the right rail of a desktop
     publisher page, on the same stand-in page as the other desktop placements:
     a serif wordmark, a nav row with the site tools opposite it, then the
     article. The article does not run the page's full width here — it keeps its
     column on the left and the ad sits in a rail beside it. The unit is Google's
     outlined card: no creative at all, a headline set large over two lines, then
     a three-line description with a big rounded chevron button beside it, and
     under the card the AdChoices badge and the advertiser's name at either edge
     of the slot. -->
<app-desktop-frame>
  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- The site account button, tight against the top of the window. -->
    <div class="da-account d-flex justify-content-end">
      <i class="bi bi-person-circle" aria-hidden="true"></i>
    </div>

    <!-- The publisher wordmark. A stand-in logo, so it is set as text. -->
    <div class="da-wordmark">website</div>

    <!-- Site nav on the left, site tools on the right. -->
    <div class="da-nav d-flex flex-row align-items-start">
      <span
        *ngFor="let item of navItems"
        class="da-nav-item placeholder"
        aria-hidden="true"
      ></span>

      <div class="da-tools d-flex flex-row align-items-center ms-auto">
        <i class="bi bi-search" aria-hidden="true"></i>
        <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
        <i class="bi bi-share" aria-hidden="true"></i>
        <i class="bi bi-envelope" aria-hidden="true"></i>
        <i class="bi bi-rss" aria-hidden="true"></i>
      </div>
    </div>

    <!-- The article column and the ad rail beside it. -->
    <div class="da-content d-flex flex-row">
      <!-- The article the ad sits beside, and the lead image the window cuts
           off. Same skeleton as the placements that run above the article, just
           in a narrower share of the page. -->
      <div class="da-article">
        <div class="da-bars d-flex flex-column">
          <span
            *ngFor="let bar of bodyBars; let last = last"
            class="da-bar placeholder"
            [class.da-bar-short]="last"
            aria-hidden="true"
          ></span>
        </div>

        <div class="da-block" aria-hidden="true"></div>
      </div>

      <!-- START: Real ad -->
      <!-- The slot is white where the page is grey, and holds two things: the
           outlined card, and the attribution row under it. -->
      <div class="da-ad d-flex flex-column">
        <div class="da-creative d-flex flex-column">
          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
            {{ data.headlines[0] || "Your headline appears here" }}
          </a>

          <!-- The description and the call to action share the row at the foot
               of the card, the description centred against the button's height. -->
          <div class="da-body d-flex flex-row align-items-center">
            <div class="da-desc">
              {{ data.descriptions[0] || "Your description appears here" }}
            </div>

            <!-- This placement draws the call to action as the chevron alone —
                 there is nowhere in the unit for its label — so the authored
                 text becomes the link's accessible name instead of being
                 dropped. -->
            <a
              [href]="data.url" target="_blank" rel="noopener noreferrer"
              class="da-cta d-flex align-items-center justify-content-center"
              [attr.aria-label]="data.ctaText || 'Your call to action'"
            >
              <i class="bi bi-chevron-right" aria-hidden="true"></i>
            </a>
          </div>
        </div>

        <!-- Outside the card, at the foot of the slot. -->
        <div class="da-attr d-flex flex-row align-items-center">
          <!-- The AdChoices badge is chrome the network draws over the unit, so
               it is decorative here. Nothing else in this slot comes from
               Google — there is no dismiss control on this placement. -->
          <span
            class="da-adchoices d-flex align-items-center justify-content-center"
          >
            <i class="bi bi-info-circle" aria-hidden="true"></i>
          </span>

          <!-- The mock names the advertiser here rather than showing a mark.
               GenSingleImagePreviewData carries no advertiser field, so the
               name is a literal here, the same compromise the other
               placements make. -->
          <span class="da-advertiser ms-auto">Valamar</span>
        </div>
      </div>
      <!-- END: Real ad -->
    </div>
  </div>
  <!-- END: Publisher page -->
</app-desktop-frame>
